import { render } from "./importExcel.vue?vue&type=template&id=3fc3d532&scoped=true"
import script from "./importExcel.vue?vue&type=script&lang=js"
export * from "./importExcel.vue?vue&type=script&lang=js"

import "./importExcel.vue?vue&type=style&index=0&id=3fc3d532&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3fc3d532"

export default script